import React from 'react';
import {useDispatch} from 'react-redux';
import {
    dpDetailUrl,
    marketingSsoAuthorizeUrl,
    promotionSsoUrl,
} from 'Utils/urlUtil';
import {T} from 'Actions/translate';
import {openNotification} from 'Actions/notification';
import {post} from 'Utils/apiUtil';
import util from 'Utils/commonUtil';

const PMPromotion = (props) => {
    const {
        activityBasicTypeName,
        hotWords,
        title,
        startTime,
        endTime,
        tieredPricing,
        coupon,
    } = props.activity;
    return (
        <div className="promotion-item">
            <div className="promotion-name">
                <span>
                    <span>{activityBasicTypeName}</span>
                    {hotWords && (
                        <span className="promotion-tag">{hotWords}</span>
                    )}
                </span>
                <div
                    style={{
                        margin: '5px 0',
                        textAlign: 'right',
                        fontSize: '13px',
                        color: '#666',
                    }}>
                    {startTime}
                    {' ~ '}
                    {endTime}
                </div>
            </div>
            <div className="promotion-description">{title}</div>
            <div className="price-tiers">
                {tieredPricing.map((tier, index) => {
                    const isBestValue =
                        tieredPricing &&
                        tieredPricing.length > 1 &&
                        index === tieredPricing.length - 1;
                    return (
                        <div
                            className={`price-tier ${
                                isBestValue ? 'best-value' : ''
                            }`}
                            key={`tier-${index}`}>
                            {isBestValue && (
                                <span className="best-value-tag">
                                    {T('BestDiscount')}
                                </span>
                            )}
                            <div className="tier-price">
                                <span className="price-currency">¥</span>
                                <span className="price-amount">
                                    {tier.finalPrice}
                                </span>
                                <div className="price-original">
                                    ¥{tier.listPrice}
                                </div>
                            </div>
                            <div className="tier-quantity">
                                {T('MinOrderQty')}: {tier.minOrderQty || 1}
                            </div>
                            {tier.savingPercentage && (
                                <div className="tier-discount">
                                    <span>{T('Savings')} </span>
                                    {tier.savingPercentage}
                                    {'%'}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            {coupon && (
                <div className="promotion-action">
                    <div
                        className="promo-code"
                        onClick={() => {
                            props.copyContent && props.copyContent(coupon);
                        }}>
                        {coupon}
                        <svg
                            className="copy-icon"
                            viewBox="0 0 1024 1024"
                            width="16"
                            height="16">
                            <path
                                d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z"
                                fill="currentColor"
                            />
                            <path
                                d="M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32z m-40 502.7H232V264h432v430.7z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <div
                        style={{
                            color: '#666',
                            fontSize: '12px',
                        }}>
                        {T('COPYPROMOTOUSE')}
                    </div>
                </div>
            )}
        </div>
    );
};

const DPPromotion = (props) => {
    const dispatch = useDispatch();
    const openPromotionFailedNotification = () => {
        dispatch(openNotification(T('OpenActivityPageFailed'), 'danger'));
    };
    const {
        activityBasicTypeName,
        hotWords,
        title,
        startTime,
        endTime,
        activityId,
    } = props.activity;
    const getPromotionTargetUrl = () => {
        const customerData = props.customerData || {};
        const orderChannel = util.getPurchaseOrderMode();
        return dispatch(
            post(promotionSsoUrl, {
                activityId,
                returnUrl: `${dpDetailUrl}${activityId}`,
                shipToNum: customerData.shipToNum,
                customerEmail: customerData.customerEmail,
                orderChannel,
            }),
        )
            .then((res) => {
                if (
                    res &&
                    res.status === 'success' &&
                    res.data &&
                    res.data.ticket
                ) {
                    return `${marketingSsoAuthorizeUrl}?ticket=${encodeURIComponent(
                        res.data.ticket,
                    )}`;
                }
                openPromotionFailedNotification();
                return null;
            })
            .catch(() => {
                openPromotionFailedNotification();
                return null;
            });
    };
    const handleOpenActivityMobile = () => {
        getPromotionTargetUrl().then((targetUrl) => {
            if (targetUrl) {
                window.location.href = targetUrl;
            }
        });
    };
    const handleOpenActivityPc = () => {
        const promotionWindow = window.open('', '_blank');
        getPromotionTargetUrl().then((targetUrl) => {
            if (targetUrl) {
                if (promotionWindow) {
                    promotionWindow.location.href = targetUrl;
                } else {
                    window.location.href = targetUrl;
                }
                return;
            }
            if (promotionWindow) {
                promotionWindow.close();
            }
        });
    };
    const handleOpenActivity = (e) => {
        e.preventDefault();
        if (util.isPhone()) {
            handleOpenActivityMobile();
            return;
        }
        handleOpenActivityPc();
    };
    return (
        <div className="promotion-item">
            <div className="promotion-name">
                <span>
                    {activityBasicTypeName}
                    {hotWords && (
                        <span className="promotion-tag">{hotWords}</span>
                    )}
                </span>
                <div
                    style={{
                        margin: '5px 0',
                        textAlign: 'right',
                        fontSize: '13px',
                        color: '#666',
                    }}>
                    {startTime}
                    {' ~ '}
                    {endTime}
                </div>
            </div>
            <div className="promotion-description">{title}</div>
            <div className="promotion-action">
                <span onClick={handleOpenActivity} className="activity-link">
                    {T('GoToActivity')}
                    <svg className="arrow-icon" viewBox="0 0 1024 1024">
                        <path
                            d="M765.7 486.8L314.9 134.7c-5.3-4.1-12.9-0.4-12.9 6.3v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1c16.4-12.8 16.4-37.6 0-50.4z"
                            fill="currentColor"
                        />
                    </svg>
                </span>
            </div>
        </div>
    );
};

const Promotions = (props) => {
    console.log('Promotions props:', props);
    const promotions = props.promoData && props.promoData.promotions;
    if (!promotions) return null;
    return (
        <div className="promotion-container">
            {/* Promotion Section */}
            <div className="promotion-section">
                <div className="promotion-header">
                    <h3 className="promotion-title">{T('PromoDetails')}</h3>
                    <span className="promotion-count">
                        {promotions.length} 个
                    </span>
                </div>

                <div className="promotion-list">
                    {promotions.map((promo, index) =>
                        promo.category === 'PM' ? (
                            <PMPromotion
                                key={`pm-${index}`}
                                activity={promo}
                                copyContent={props.copyContent}
                                customerData={props.customerData}
                            />
                        ) : (
                            <DPPromotion
                                key={`dp-${index}`}
                                activity={promo}
                                customerData={props.customerData}
                            />
                        ),
                    )}
                </div>
            </div>
        </div>
    );
};

export default Promotions;
